var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPercents = function SvgPercents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 0.731763C6.34375 0.447597 6.58095 0.218325 6.86253 0.256553C9.30664 0.588366 11.2415 2.52321 11.5733 4.96732C11.6115 5.2489 11.3823 5.4861 11.0981 5.4861H6.84375C6.56761 5.4861 6.34375 5.26224 6.34375 4.9861V0.731763Z",
    fill: "#C39A91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23918 6.04991C5.96304 6.04991 5.73918 5.82605 5.73918 5.54991V0.81073C5.73918 0.534587 5.51455 0.308455 5.23943 0.332187C2.3038 0.585416 0 3.04865 0 6.04991C0 9.21954 2.56954 11.7891 5.73918 11.7891C8.74044 11.7891 11.2037 9.48528 11.4569 6.54965C11.4806 6.27453 11.2545 6.04991 10.9784 6.04991H6.23918Z",
    fill: "#C39A91"
  })));
};
export default SvgPercents;